module.exports = function(obj){
var __t,__p='',__j=Array.prototype.join,print=function(){__p+=__j.call(arguments,'');};
with(obj||{}){
__p+='<div class="row">\n  <div class="col-xs-12 content-region"></div>\n</div>\n<div class="row">\n  <div class="col-xs-12 select-btn-region"></div>\n</div>\n';
}
return __p;
};



/*****************
 ** WEBPACK FOOTER
 ** ./assets/js/common/locations-map/feature-popup-content/feature-popup-content-layout.tpl
 ** module id = 333
 ** module chunks = 1 7 9 33 51 146
 **/